
  import "./App.css";
  import Home from "./Pages/Home";
  import CoursePage from "./Pages/CoursePage";
  import { BrowserRouter as Router, Route, Routes ,useLocation, matchPath,} from "react-router-dom";
  import Landing_Page from "./Pages/Landing_Page";
  import Log from "./Pages/Log";
  import RegisterPage from "./Pages/RegisterPage";
  import DashboardStudent from "./Pages/DashboardStudent";
  import Profile from "./Pages/Profile";
  import Courses from "./Pages/Courses";
  import Certificates from "./Pages/Certificates";
  import Dashboard from "./Pages/Dashboard";
  import Achievements from "./Pages/Achievements";
  import AdminDashboard from "./Pages/AdminDashboard";
  import AddCourses from "./Pages/AddCourses";
  import AdminNav from "./Pages/AdminNav";
  import AccessPlan from "./Pages/AccessPlan";
  import Editingtool from "./Pages/Editingtool";
  import RightSidebar from "./Pages/RightSidebar";
  import AaasDashboard from "./Pages/AaasDashboard";
  import RghtSdebar from "./Pages/RghtSdebar";
  import StudentSdebar from "./Pages/StudentSdebar";
  import Notification from "./Pages/Notification";
  import ResetPassword from "./Pages/ResetPassword";
  import Wishlist from "./Pages/Wishlist";
  import CourseDetails from "./Pages/CourseDetails";
  import About from "./Pages/About";
  import ForgotPasswordModal from "./Components/ForgotPasswordModal";
  import TmsDashboard from "./TmsPages/TmsDashboard";
  import Training from "./TmsPages/Training";
  import TmsParticipants from "./TmsPages/TmsParticipants";
  import PendingTraining from "./TmsPages/PendingTraining";
  import AddParticipants from "./TmsPages/AddParticipants";
  import UpcomingTraining from "./TmsPages/UpcomingTraining";
  import DeclinedTraining from "./TmsPages/DeclinedTraining";
  import CreateAssessment from "./TmsPages/CreateAssessment";
  import ViewEvent from "./TmsPages/ViewEvent";
  import Quiz from "./TmsPages/Quiz";
  import SelfRegistration from "./TmsPages/SelfRegistration";
  import TmsResult from "./TmsPages/TmsResult";
  import BotComponent from "./BotComponent 1";
  import Setting from "./Pages/Setting";
  import ViewCertificate from "./Components/ViewCertificate";
  import  SettingsLayout  from "./Components/SettingsLayout";
  import { NotificationSettings } from "./Pages/NotificatonSettings";
  import { LoginInformation } from "./Pages/LoginInformation";
  import { Privacy } from "./Pages/Privacy";
  import { GroupInvites } from "./Pages/GroupInvites";
  import { ExportData } from "./Pages/ExportData";
  import { DeleteAccount } from "./Pages/DeleteAcc";
  import LMSMessages from "./Pages/LMSMessage";
  import AddCourse from "./Pages/AddCourseN";
  import ProfilePage from "./Pages/ProfileNew";
  import MembersPage from "./Pages/MemberPage";
  import EditProfile from "./Pages/EditProfile";
  import CreateCoursePage from "./Pages/CourseAdd";
  import TimelineSection from "./Components/Profile Section/TimelineSection";
  import GroupsPage2 from "./Pages/GroupPage";
  import CreatedGroupPage from "./Pages/CreatedGroup";
  import ChatComponent from "./Pages/MessageTest";
  import CreateMembership from "./Pages/CreateMembership";
  import AddCourseInfo from "./Components/AddCourseSection/AddCourseInfo";
  import CreateGroupPage2 from "./Pages/CreateGroupPage2";
  import FeedsPage from "./Pages/FeedsPage";
  import MyCourses from "./Pages/MyCourses";
  import Homeee from '../src/Homee';
  import Reports from './Pages/Reports'
  import Membership from "./Pages/Membership";
  import StudentMyMembership from "./Pages/StudentMyMembership";
  function App() {
    return (
      <>
        <Router>
          <MainApp />
        </Router>
      </>
    );
  }

  // function MainApp() {
  //   const location = useLocation();
  //    const token = localStorage.getItem("jwttoken");
  //   const authRoutes = ["/log", "/quiz/:quiz_id", "/RegisterPage"];
  //   const isAuthRoute =
  //     authRoutes.some(route => matchPath(route, location.pathname)) ||
  //     (location.pathname.startsWith("/reset-password") &&
  //       location.pathname.split("/").length === 4);
  // if (!token && !isAuthRoute) {
  //   window.location.href = "/Log";
  //   return null;
  // }

  function MainApp() {
  const location = useLocation();
  const token = localStorage.getItem("jwttoken");

  const authRoutes = [
    "/log",
    "/RegisterPage",
    "/forgot-password",
    "/reset-password",
    "/quiz/:quiz_id",
  ];

  const isAuthRoute = authRoutes.some(route =>
    matchPath(route, location.pathname)
  );

  if (!token && !isAuthRoute) {
    window.location.href = "/Log";
    return null;
  }
    return (
      <>
        <Routes>
        <Route path="/lmsadmindashboard" element={<Homeee />} />

          <Route path="/Home" element={<Home />} />
          <Route path="/CoursePage" element={<CoursePage />} />
          <Route path="/" element={<Landing_Page />} />
          <Route path="/Dashboard-student" element={<DashboardStudent />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/adminNav" element={<AdminNav />} />
          <Route path="/rghtsdebar" element={<RghtSdebar />} />
          <Route path="/studentSdebar" element={<StudentSdebar />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/About" element={<About />} />
          <Route path="/Notification" element={<Notification />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/view-certificate/:id" element={<ViewCertificate/>}/>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/achievements" element={<Achievements />} />
          <Route path="/AdminDashboard" element={<AdminDashboard />} />
          <Route path="/addcourses" element={<AddCourses />} />
          <Route path="/accessPlan" element={<AccessPlan />} />
          <Route path="/editingtool" element={<Editingtool />} />
          <Route path="/rightSidebar" element={<RightSidebar />} />
          <Route path="/aaasDashboard" element={<AaasDashboard />} />
          <Route path="/Log" element={<Log />} />
          <Route path="/RegisterPage" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordModal />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/Wishlist" element={<Wishlist />} />
          <Route path="/Course/:id" element={<CourseDetails />} />
          <Route path="/tmsdashboard" element={<TmsDashboard />} />
          <Route path="/training" element={<Training />} />
          <Route path="/participants" element={<TmsParticipants />} />
          <Route path="/pendingtraining" element={<PendingTraining />} />
          <Route path="/addparticipants" element={<AddParticipants />} />
          <Route path="/upcomingtraining" element={<UpcomingTraining />} />
          <Route path="/declinedtraining" element={<DeclinedTraining />} />
          <Route path="/createassessment" element={<CreateAssessment />} />
          <Route path="/viewevent/:training_id" element={<ViewEvent />} />
          <Route path="/quiz/:quiz_id" element={<Quiz />} />
          <Route path="/selfregistration/:training_id" element={<SelfRegistration />} />
          <Route path="/result" element={<TmsResult />} />
          <Route path="/settings" element={<Setting />} />
          <Route path="/lmsmessage" element={<LMSMessages />} />
          <Route path="/profilenew" element={<ProfilePage />} />
          <Route path="timeline" element={<TimelineSection />} />
          <Route path="/memberpage" element={<MembersPage />} />
          <Route path="/editprofile" element={<EditProfile />} />          
          <Route path="/settingslayout" element={<SettingsLayout/>}/>
          <Route path="notifications" element={<NotificationSettings />} />
          {/* <Route path="login" element={<LoginInformation />} /> */}
          <Route path="privacy" element={<Privacy />} />
          <Route path="groupinvites" element={<GroupInvites />} />
          <Route path="exportdata" element={<ExportData />} />
          <Route path="deleteaccount" element={<DeleteAccount/>} />
          <Route path="/createcourse" element={<CreateCoursePage/>} />
          <Route path="/createmembership" element={<CreateMembership/>} />
          <Route path="/createdgroup" element={<CreatedGroupPage/>}/>
          <Route path="/textmessage/:id" element={<ChatComponent/>} />
          <Route path="/addcourseinfo/:id" element={<AddCourseInfo/>} />
          <Route path="/group" element={<GroupsPage2/>}/>
          <Route path="/group/:id" element={<CreateGroupPage2/>} />
          <Route path="/feeds" element={<FeedsPage/>}/>
          <Route path="/MyCourses" element={<MyCourses/>} />
          <Route path="/reports" element={<Reports/>} />
          <Route path="/membership" element={<Membership/>} />
          <Route path="/mymembership" element={<StudentMyMembership/>} />
        </Routes>
        {!isAuthRoute && <BotComponent />}
      </>
    );
  }

  export default App;